import { render, staticRenderFns } from "./CreatedDocuments.vue?vue&type=template&id=33a6c4dc"
import script from "./CreatedDocuments.vue?vue&type=script&lang=ts"
export * from "./CreatedDocuments.vue?vue&type=script&lang=ts"
import style0 from "./CreatedDocuments.vue?vue&type=style&index=0&id=33a6c4dc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports